import { render } from "./Spouse.vue?vue&type=template&id=a9f1e5da&scoped=true"
import script from "./Spouse.vue?vue&type=script&lang=js"
export * from "./Spouse.vue?vue&type=script&lang=js"

import "./Spouse.vue?vue&type=style&index=0&id=a9f1e5da&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a9f1e5da"]])

export default __exports__